var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-4.35-4.35M19 11a8 8 0 11-16 0 8 8 0 0116 0z",
    stroke: "#63656E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSI+CjxwYXRoIGQ9Ik0yMSAyMS4wMDAyTDE2LjY1IDE2LjY1MDJNMTkgMTEuMDAwMkMxOSAxNS40MTg1IDE1LjQxODMgMTkuMDAwMiAxMSAxOS4wMDAyQzYuNTgxNzIgMTkuMDAwMiAzIDE1LjQxODUgMyAxMS4wMDAyQzMgNi41ODE5NyA2LjU4MTcyIDMuMDAwMjQgMTEgMy4wMDAyNEMxNS40MTgzIDMuMDAwMjQgMTkgNi41ODE5NyAxOSAxMS4wMDAyWiIgc3Ryb2tlPSIjNjM2NTZFIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+";
export { SvgSearch as ReactComponent };